import React, { useContext } from 'react'

import { TitleContext } from '@providers/TitleProvider'
import TitleService from '@services/TitleService'
import { useSession } from '@stores/globalData/globalData.store'
import GoogleTagManager from '@utils/gtm/google-tag-manager'

import SocialIcon from './SocialIcon'

const Favorites: React.FC = () => {
  const session = useSession()

  const { title, updateTitle } = useContext(TitleContext)

  const setFavorited = (favorited?: boolean): void => {
    const mod = favorited ? 1 : -1
    const favorites = Math.max((title.favorites || 0) + mod, 0)
    updateTitle({
      favorited,
      favorites,
    })
  }

  // for the sake of UI responsiveness
  // assume it works and correct if otherwise when the response comes back
  const toggleFavorite = (): void => {
    const originalStatus = title.favorited
    const promise = TitleService.toggleFavorite(title)
    setFavorited(!originalStatus)
    // old fasioned promise pattern because we want to
    // do some stuff between kicking off the request and dealing with the response
    promise.then((success: boolean): void => {
      if (!success) {
        setFavorited(originalStatus)
      } else {
        GoogleTagManager.trackEvent(title.favorited ? 'title_favorite' : 'title_unfavorite', {
          content_title: {
            id: title.uuid,
          },
          favorite_context: 'social_icon',
        })
      }
    })
    // if the endpoints fails set it back to the original value
  }

  return (
    <SocialIcon
      className={
        title.favorited
          ? 'nf-favorite-solid text-orange'
          : 'nf-favorite-outline text-black-dark dark:text-gray'
      }
      onClick={session.isLoggedIn() ? toggleFavorite : undefined}
      count={title.favorites}
    />
  )
}

export default Favorites
